/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Volume_HighInputs */

const en_us2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const pt_br2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const es_419_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const pt_pt2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const fr_fr2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fort`)
};

const de_de2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoch`)
};

const it_it2_workout_logging_volume_high = /** @type {(inputs: Workout_Logging_Volume_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {Workout_Logging_Volume_HighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_volume_high = /** @type {((inputs?: Workout_Logging_Volume_HighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Volume_HighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_volume_high(inputs)
	if (locale === "es-419") return es_419_workout_logging_volume_high(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_volume_high(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_volume_high(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_volume_high(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_volume_high(inputs)
	return en_us2_workout_logging_volume_high(inputs)
});
export { workout_logging_volume_high as "workout-logging.volume_high" }